PJQ.views.rfi.RFIManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'RFI-Management')
    },
    events: {
        'click .btn-export-summary': 'exportSummary',
        'click .btn-export-detailed': 'exportDetailed',
        'click .btn-rfi-settings': 'viewRFISettings',
        'click .btn-add-rfi': 'addRFI',
        'click .btn-edit-rfi': 'editRFIClicked',
        'click .btn-delete-rfi': 'deleteRFIClicked'
    },
    beforeFirstRender: function () {
        if (PJQ.app.session.user == null) {
            this.options.isAdmin = false;
        } else {
            this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
                && this.options.project.hasPermission('rfi.isAdmin');
        }

        this.isFetched = false;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        this.options.userSettings = new PJQ.models.rfi.UserSettings();
        let fnFetch = _.bind(function(){
            this.options.userSettings.fetch({
                success: _.bind(function () {
                    let fnRender = _.bind(function (customFields) {
                        this.options.customFields = customFields;
                        if (this.collection == null && this.options.project != null) {
                            this.options.project.fetchRFIs(_.bind(function (rfis) {
                                this.collection = rfis;
                                this.isFetched = true;
                                this.render();
                            }, this));
                        } else {
                            this.isFetched = true;
                        }
                    }, this);
                    if (this.options.project != null) {
                        this.options.project.fetchRFICustomFields(_.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    } else {
                        PJQ.app.session.fetchRFICustomFields(null, _.bind(function (customFields) {
                            fnRender(customFields);
                        }, this));
                    }
                }, this)
            });
        }, this)

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            this.options.project.fetchLocations(_.bind(function (locations) {
                this.locations = locations;
                fnFetch();
            }, this));
        } else {
            fnFetch();
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            settings: this.options.settings
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.rfiId > 0) {
            let rfi = this.collection.get(this.options.rfiId);
            this.options.rfiId = null;
            if (rfi != null) {
                rfi.fetch({
                    success: _.bind(function () {
                        this.editRFI(rfi);
                    }, this)
                });
            }
        }

        this.renderDataTable();
    },
    renderDataTable() {
        let self = this;
        this.rfiDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.rfi-table'),
            rowId: "cid",
            pageLength: this.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).rowsPerPage,
            data: this.collection.models,
            onPageSizeChange: _.bind(function (value) {
                this.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS).rowsPerPage = value;
                this.options.userSettings.save();
            }, this),
            settings: this.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS),
            language: {
                emptyTable: 'Click "Add RFI" to create a new RFI',
                zeroRecords: "No RFI matched the search criteria"
            },
            rowCallback: function (row, data) {
                if (!data.get('isRead') && self.options.isAdmin) {
                    $(row).addClass('unread-highlight')
                } else {
                    $(row).removeClass('unread-highlight')
                }
            },
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'Data-Table-Header-RFI')
            },
            headerData: function () {
                return {
                    project: self.options.project,
                    settings: self.options.settings,
                    preferences: self.preferences
                };
            },
            afterHeaderRender: _.bind(function (view, $header) {
                new PJQ.inputs.Selectpicker({
                    el: $header.find('.rfi-status-filter'),
                    onChange: function (value) {
                        view.setFilter('status', value);
                    },
                    isIntChoices: true,
                    isMultiple: true,
                    noneSelectedText: 'No Filters'
                });

                if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                    this.locationFilterPicker = new PJQ.inputs.ProjectLocationPicker({
                        el: this.$('.filter-location'),
                        project: this.options.project,
                        isMultiple: true,
                        onChange: _.bind(function (value) {
                            view.setFilter('location', value);
                        }, this)
                    });
                }
            }, this),
            getFilterData: function (view, data) {
                let result = data,
                    locationFilter = view.getFilter('location');
                if(_.size(locationFilter) > 0){
                    result = _.filter(data, function (row) {
                        return _.contains(locationFilter, row.get('locationId'));
                    }, this);
                }

                let statusFilter = view.getFilter('status');
                if (_.size(statusFilter) === 0) {
                    return result;
                }

                return _.filter(result, function (row) {
                    return _.contains(statusFilter, row.get('status'));
                });
            },
            order: [[0, "asc"]],
            deferRender: true,
            onRowDoubleClick: _.bind(function (row) {
                let selectedRFI = row.data();
                selectedRFI.fetch({
                    success: _.bind(function () {
                        this.editRFI(selectedRFI);
                    }, this)
                });
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editRFI(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteRFI(row);
                        }, this)
                    }
                ]
            },
            columns: this.getColumns(false),
            colReorder: {
                fixedColumnsLeft: 0,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                if (this.options.userSettings != null) {
                    this.options.userSettings.save();
                }
            }, this)
        });
    },
    getColumns(includeAllColumns) {
        let columns = [], includeColumns = [],
            viewSettings = this.options.userSettings.getSettings(PJQ.constants.rfi.view.RFIS);

        if (includeAllColumns) {
            includeColumns = ["number", "title", "question", "location", "groupList", "requestedBy", "assigneeList", "ballInCourt", "distributionList", "dueDate", "status"];
        } else
            includeColumns = viewSettings.columns;

        if (this.options.isAdmin && !includeAllColumns) {
            columns.push({
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderData": [0, 1],
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    if (!row.get('isRead')) {
                        return '<i class="fas fs-18 text-primary fa-exclamation-circle" title="Changes have been made since last viewed by your company"></i>';
                    }
                    return '<div hidden>999</div>';
                }
            })
        }

        _.each(includeColumns, _.bind(function (column) {
            switch (column) {
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": {
                            "_": "attributes.number",
                            "sort": _.bind(function (row) {
                                let number = parseInt(row.attributes.number);
                                if (isNaN(number)) {
                                    return row.attributes.number;
                                } else {
                                    return number
                                }
                            }, this),
                            "display": "attributes.number"
                        },
                        "title": "Number",
                        "width": "80px",
                        "type": 'natural-ci',
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'title':
                    columns.push({
                        columnData: 'title',
                        data: "attributes.title",
                        title: "Title",
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'question':
                    columns.push({
                        columnData: 'question',
                        data: "attributes.question",
                        title: "Question",
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'location':
                    columns.push({
                        columnData: 'location',
                        data: "attributes.location",
                        title: "Location",
                        render: _.bind(function (data, type, row) {
                            if(this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)){
                                let location = this.locations.get(row.get('locationId'));
                                return location ? this.locations.getFullName(location) : '';
                            }
                            return data;
                        }, this),
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'groupList':
                    columns.push({
                        columnData: 'groupList',
                        title: "Trades",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.groups.models) > 0) {
                                _.each(row.groups.models, function (group) {
                                    result.push(group.get('groupName'));
                                });
                            } else {
                                result.push('None');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'assigneeList':
                    columns.push({
                        columnData: 'assigneeList',
                        title: "Assignee",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.assigneeList.models) > 0) {
                                _.each(row.assigneeList.models, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'ballInCourt':
                    columns.push({
                        columnData: 'ballInCourt',
                        data: "attributes.ballInCourt",
                        title: "Ball In Court",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.ballInCourt.models) > 0) {
                                _.each(row.ballInCourt.models, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'distributionList':
                    columns.push({
                        columnData: 'distributionList',
                        title: "Distribution List",
                        render: function (data, type, row) {
                            let result = [];
                            if (_.size(row.distributionList.models) > 0) {
                                _.each(row.distributionList.models, function (contact) {
                                    result.push(PJQ.helpers.contacts.getContactAnchor({contact: contact}));
                                });
                            } else {
                                result.push('Nobody');
                            }
                            return result.join(', ');
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        columnData: "dueDate",
                        data: "attributes.dueDate",
                        title: "Response Due",
                        searchable: false,
                        width: '220px',
                        render: function (data, type, row) {
                            if (data != null) {
                                let itemDueDate = new Date(data),
                                    dateString = PJQ.helpers.dateHelpers.getDateString(itemDueDate, PJQ.helpers.dateHelpers.dateFormats.DATE),
                                    overdueDays = PJQ.helpers.dateHelpers.getDateDaysDiff(new Date(), itemDueDate);
                                if (row.get('status') !== PJQ.constants.rfi.statuses.CLOSED && overdueDays > 0) {
                                    return '<span class="text-danger font-weight-bold">' + dateString + '(' + overdueDays.toString() + 'd overdue)' + '</span>';
                                }
                                return dateString;
                            }
                            return 'Not Set';
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'requestedBy':
                    columns.push({
                        columnData: 'requestedBy',
                        title: "Requested By",
                        render: function (data, type, row) {
                            return PJQ.helpers.contacts.getContactAnchor({contact: row.requestedBy});
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
                case 'status':
                    columns.push({
                        columnData: 'status',
                        data: "attributes.status",
                        title: "Status",
                        width: "80px",
                        render: function (data, type, row) {
                            return '<span style="color:' + row.getStatusColor() + '">' + row.getStatusName() + '</span>';
                        },
                        visible: viewSettings.columns.indexOf(column) !== -1
                    });
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                data: "attributes.rfiId",
                title: "",
                width: '80px',
                orderable: false,
                searchable: false,
                className: 'text-align-center',
                render: _.bind(function () {
                    let html = '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-rfi"><i class="fal fa-pencil"></i></button>';
                    if (this.options.isAdmin) {
                        html += '<button type="button" class="btn btn-danger btn-delete-rfi ml-1"><i class="fal fa-trash"></i></button>';
                    }
                    html += '</div>';
                    return html;
                }, this)
            });
        }

        return columns;
    },
    addRFI() {
        let newRFI = new PJQ.models.rfi.RFI({
            projectId: PJQ.app.session.project.id
        });
        this.editRFI(newRFI);
    },
    editRFIClicked(e) {
        let row = this.rfiDataTable.getRow($(e.currentTarget).parents('tr')),
            selectedRFI = row.data();
        selectedRFI.fetch({
            success: _.bind(function () {
                this.editRFI(selectedRFI);
            }, this)
        });
    },
    editRFI(rfi) {
        let isNew = rfi.isNew();
        new PJQ.views.rfi.EditRFIModal({
            model: rfi,
            project: this.options.project,
            onClose: _.bind(function (rfi) {
                this.rfiDataTable.refresh();
            }, this),
            onSave: _.bind(function (rfi) {
                if (isNew) {
                    this.collection.add(rfi);
                    this.rfiDataTable.addRow(rfi);
                }
                this.rfiDataTable.refresh();
            }, this),
            onDelete: _.bind(function (rfi) {
                let row = this.rfiDataTable.getRow(rfi.cid);
                if (row != null) {
                    this.rfiDataTable.removeRow(row);
                }
                rfi.destroy();
                this.rfiDataTable.refresh();
            }, this)
        });
    },
    deleteRFIClicked: function (e) {
        let row = this.rfiDataTable.getRow($(e.currentTarget).parents('tr'));
        this.deleteRFI(row);
    },
    deleteRFI(row) {
        let rfi = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this RFI?",
            onDelete: _.bind(function () {
                rfi.destroy();
                this.rfiDataTable.removeRow(row);
            }, this)
        });
    },
    exportSummary: function () {
        this.exportList("SUMMARY");
    },
    exportDetailed: function () {
        this.exportList();
    },
    exportList: function (type) {
        let loader = new PJQ.Loader(this.$('.btn-rfi-export'), {
            loadingText: "Exporting..."
        });
        let params = [];
        if (_.size(type) > 0) {
            params.push({
                parameter: 'type',
                value: type
            });
        }

        let statusFilter = this.rfiDataTable.getFilter('status');
        //if (_.size(this.rfiDataTable.getSearchText()) > 0 || _.size(statusFilter) > 0) {
            params.push({
                parameter: 'ids',
                value: _.map(this.rfiDataTable.getFilteredRowData(), function (rfi) {
                    return rfi.id;
                })
            });
        //}

        params.push({
            parameter: 'timeZoneOffset',
            value: new Date().getTimezoneOffset()
        })

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'rfi',
                },
                {
                    endpoint: 'export'
                }
            ], params),
            isAPI2: true
        }).get().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
            PJQ.notifications.notify.successNotify({
                message: 'RFIs Successfully Exported'
            });
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            loader.remove();
            PJQ.notifications.notify.errorNotify({
                message: 'Failed to export RFIs'
            });
        }, this));
    },
    viewRFISettings: function () {
        new PJQ.views.rfi.RFISettingsModal({
            rfiView: this,
            userSettings: this.options.userSettings,
            onSave: _.bind(function () {
                this.renderDataTable();
            }, this)
        });
    }
});

PJQ.views.rfi.EditRFIModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'Modal-Edit-RFI'),
        subTemplates: {
            responses: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'Responses'),
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts')
        },
        width: '90%',
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .add-response': 'addResponseClicked',
        'click .edit-history': 'viewEditHistory',
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-export': 'exportPDF',
        'click .btn-save': 'saveClicked',
        'click .btn-save-open': 'saveAndOpenClicked',
        'click .btn-save-draft': 'saveDraftClicked',
        'click .btn-close': 'close',
        'click .rfi-delete': 'delete',
        'click .btn-rfi-open': 'openRFI',
        'click .btn-rfi-close': 'closeRFI',
        'click .btn-accept-response': 'acceptResponse',
        'click .btn-un-accept-response': 'unAcceptResponse',
        'click .btn-download-all-attachments': 'downloadAllAttachments'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        let fnRender = _.bind(function (customFields) {
            this.options.customFields = customFields;
            this.isFetched = true;

            if(this.model.isNew() && this.options.project && this.options.project.hasPermission('rfi.isAdmin')){
                this.model.set({
                    isPublic: this.preferences.hasPref(PJQ.constants.preferenceTypes.RFI_DEFAULT_PUBLIC),
                    shouldNotifyProjectContacts: this.preferences.hasPref(PJQ.constants.preferenceTypes.RFI_DEFAULT_NOTIFY_PROJECT_CONTACTS),
                    shouldNotifyParticipants: this.preferences.hasPref(PJQ.constants.preferenceTypes.RFI_DEFAULT_NOTIFY_PARTICIPANTS)
                });
            }

            this.render();
        }, this);
        if (this.options.project != null) {
            this.options.project.fetchRFICustomFields(_.bind(function (customFields) {
                fnRender(customFields);
            }, this));
        } else {
            PJQ.app.session.fetchRFICustomFields(null, _.bind(function (customFields) {
                fnRender(customFields);
            }, this));
        }
        this.changedAnnotations = new PJQ.collections.drawings.Annotations();
    },
    beforeRender: function () {
        if (PJQ.app.session.user == null) {
            let etcPerms = this.model.get('status') !== PJQ.constants.rfi.statuses.CLOSED && (this.model.isNew()
                || this.model.checkIsAssignee(PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user)
                || this.model.checkIsDistribution(PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user));
            this.options.canAddComment = etcPerms;
            this.options.canAddAttachment = etcPerms;
            this.options.canEdit = this.model.isNew();
            this.options.isAdmin = false;
        } else {
            this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId') && this.options.project.hasPermission('rfi.isAdmin');
            let etcPerms = this.model.get('status') !== PJQ.constants.rfi.statuses.CLOSED && (this.options.isAdmin || this.model.isNew()
                || this.model.checkIsAssignee(PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user)
                || this.model.checkIsDistribution(PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user));
            this.options.canAddComment = etcPerms;
            this.options.canAddAttachment = etcPerms;
            this.options.canEdit = this.model.isNew()
                || (this.model.get('status') !== PJQ.constants.rfi.statuses.CLOSED && this.options.isAdmin);
        }
    },
    renderData: function () {
        return {
            model: this.model,
            canAddComment: this.options.canAddComment,
            canAddAttachment: this.options.canAddAttachment,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            preferences: this.preferences
        };
    },
    afterRender: function () {
        if (this.isFetched) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ],
                afterChange: _.bind(function ($e, attr, val) {
                    if (attr === 'isPublic') {
                        let $ph = this.$('.public-hide');
                        if (val) {
                            $ph.removeClass('hidden');
                        } else {
                            this.model.set({
                                shouldNotifyProjectContacts: false,
                                shouldNotifyParticipants: false
                            });
                            $ph.addClass('hidden');
                            $ph.prop('checked', false);
                        }
                    }
                }, this)
            });

            new PJQ.inputs.Datepicker({
                el: this.$('.rfi-due-date'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('dueDate')
                },
                onChange: _.bind(function (newDate) {
                    let currentDueDate = this.model.get('dueDate');
                    if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                        this.model.set('dueDate', newDate);
                    }
                }, this)
            });

            if (this.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
                new PJQ.inputs.ProjectLocationPicker({
                    el: this.$('.select-location'),
                    project: this.options.project,
                    onChange: _.bind(function (value) {
                        this.model.set('locationId', value);
                    }, this),
                    defaultValue: this.model.get('locationId')
                });
            } else {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('.rfi-location'),
                    source: _.map(_.filter(this.model.collection != null ? this.model.collection.models : [], _.bind(function (item) {
                        return _.size(item.get('location')) > 0 && item.id !== this.model.id;
                    }, this)), function (item) {
                        return item.get('location');
                    })
                });
            }

            if (this.options.isAdmin) {
                this.model.set('isRead', true);
                this.ballInCourtInput = new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.rfi-ball-in-court'),
                    contacts: new PJQ.collections.contacts.Contacts(_.union(this.model.assigneeList.models, this.model.distributionList.models)),
                    selectedContact: this.model.ballInCourt.models,
                    isSingleChoice: false,
                    isReadOnly: !this.options.canEdit,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.ballInCourt.reset(selectedContacts);
                        this.model.isDirty = true;
                    }, this)
                });

                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.rfi-assigned'),
                    context: [PJQ.constants.contacts.contexts.PARTICIPANTS, PJQ.constants.contacts.contexts.PROJECTCONTACTS],
                    selectedContact: this.model.assigneeList.models,
                    isSingleChoice: false,
                    isReadOnly: !this.options.canEdit,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.assigneeList.reset(selectedContacts);
                        this.model.isDirty = true;
                        this.refreshBallInCourtInput();
                    }, this)
                });

                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.rfi-distribution'),
                    context: [PJQ.constants.contacts.contexts.PARTICIPANTS, PJQ.constants.contacts.contexts.PROJECTCONTACTS],
                    selectedContact: this.model.distributionList.models,
                    isSingleChoice: false,
                    isReadOnly: !this.options.canEdit,
                    onChange: _.bind(function (selectedContacts) {
                        this.model.distributionList.reset(selectedContacts);
                        this.model.isDirty = true;
                        this.refreshBallInCourtInput();
                    }, this)
                });

                new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.rfi-requested-by'),
                    context: [PJQ.constants.contacts.contexts.PARTICIPANTS, PJQ.constants.contacts.contexts.PROJECTCONTACTS],
                    selectedContact: this.model.requestedBy,
                    isReadOnly: !this.options.canEdit,
                    onChange: _.bind(function (selectedContact) {
                        this.model.requestedBy = selectedContact;
                        this.model.isDirty = true;
                    }, this)
                });
            }

            this.renderCustomFields();

            this.renderStatus();

            new PJQ.views.groups.GroupsSelectInput({
                el: this.$('.rfi-groups'),
                isShowAddButton: false,
                groupLevels: PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
                groupUserId: PJQ.app.session.project.get('masterUserId'),
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-groups'),
                selectedGroups: this.model.groups.models,
                onAfterSave: _.bind(function (selectedGroups) {
                    this.model.groups.reset(selectedGroups);
                    this.model.isDirty = true;
                }, this)
            });

            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.rfi-file-uploader'),
                context: 'rfi',
                contextId: this.model.id,
                canAddAnnotations: this.options.canEdit,
                onAnnotationChange: (annotation) => {
                    this.changedAnnotations.merge(annotation);
                },
                mergeAnnotations: this.changedAnnotations,
                collection: this.model.attachments,
                canUpload: this.options.canAddAttachment,
                canDelete: this.options.canEdit && this.options.isAdmin,
                includeProjectAttachments: true,
                previewImageDimension: 150,
                onSuccess: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        this.model.attachments.remove(attachment);
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderResponses();
        }
    },
    renderCustomFields: function () {
        this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
            el: this.$('.rfi-custom-fields'),
            collection: this.options.customFields,
            fieldValues: this.model.get('customFieldValues'),
            isEdit: this.options.canEdit
        });
    },
    refreshBallInCourtInput: function () {
        this.ballInCourtInput.options.contacts = new PJQ.collections.contacts.Contacts(_.union(this.model.assigneeList.models, this.model.distributionList.models));
    },
    renderStatus: function () {
        this.$('.rfi-status').css('background-color', this.model.getStatusColor());
        this.$('.rfi-status-name').html(this.model.getStatusName());

        let statusActions,
            status = this.model.get('status');
        if (status === PJQ.constants.rfi.statuses.CLOSED) {
            statusActions = '<button type="button" class="btn btn-success btn-rfi-open">Mark as Open</button>';
        } else if (status === PJQ.constants.rfi.statuses.OPEN) {
            statusActions = '<button type="button" class="btn btn-danger btn-rfi-close">Mark as Closed</button>';
        } else {
            statusActions = '';
        }
        this.$('.rfi-status-actions').html(statusActions);
    },
    exportPDF: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'rfi',
                value: this.model.id
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: 'timeZoneOffset',
                value: new Date(this.model.get('createdOn')).getTimezoneOffset()
            }
        ]));
    },
    addResponseClicked: function () {
        this.addResponse();
    },
    addResponse: function (callback) {
        let val = this.$('.item-new-response').val().trim();
        if (_.size(val) === 0)
            return;

        let response = new PJQ.models.rfi.Response({
            rfiId: this.model.id,
            responseText: val,
            createdOn: new Date()
        });
        if (!this.model.isNew()) {
            response.save(null, {
                success: _.bind(function () {
                    this.model.responses.add(response);
                    this.renderResponses();

                    if (typeof callback === 'function') {
                        callback();
                    }
                }, this)
            });
        } else {
            response.createdBy = PJQ.app.session.user;
            this.model.responses.add(response);
            this.renderResponses();

            if (typeof callback === 'function') {
                callback();
            }
        }

        this.$('.item-new-response').val('');
    },
    renderAcceptedResponses: function () {
        let acceptedResponses = _.filter(this.model.responses.models, function (response) {
                return response.get('isAccepted');
            }),
            $responses = this.$('.rfi-accepted-responses');
        if (_.size(acceptedResponses) > 0) {
            this.renderSubTemplate(false, this.options.subTemplates.responses, $responses, {
                responses: acceptedResponses,
                canEdit: this.options.canEdit
            });
        } else {
            $responses.html('<div class="fs-16 font-weight-light mt-2">No Accepted Responses</div>');
        }
    },
    renderResponses: function () {
        this.renderAcceptedResponses();
        this.renderSubTemplate(false, this.options.subTemplates.responses, this.$('.rfi-responses'), {
            responses: this.model.responses.models,
            canEdit: this.options.canEdit
        });
    },
    validate: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), true);
        if (_.size(this.$('.item-title').val()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.item-title'), false);
        }

        isValid = isValid && this.customFieldsForm.validate();

        // display/clear banner on top of page
        if (!isValid) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: 'Required fields are empty'
            });

            window.scrollTo(0, 0);
        } else {
            this.$('.validation-error').empty();
        }

        return isValid;
    },
    viewEditHistory: function () {
        new PJQ.views.punchlists.EditHistoryModal({
            collection: this.model.editHistory
        });
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    unAcceptResponse: function (e) {
        let cid = $(e.currentTarget).closest('.card').data('cid'),
            response = this.model.responses.get(cid);
        response.accept(false, _.bind(function () {
            this.renderResponses();
        }, this));
    },
    acceptResponse: function (e) {
        let cid = $(e.currentTarget).closest('.card').data('cid'),
            response = this.model.responses.get(cid);
        response.accept(true, _.bind(function () {
            this.renderResponses();
        }, this));
    },
    checkNotify: function (modalBody, callback) {
        new PJQ.views.modals.YesNo({
            header: "Send Notifications?",
            body: modalBody,
            onYes: _.bind(function () {
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this),
            onNo: _.bind(function () {
                if (typeof callback === 'function') {
                }
                callback(false);
            }, this)
        });
    },
    openRFI: function () {
        this.checkNotify('Would you like to notify users that this RFI has been opened?', _.bind(function (notify) {
            this.model.set('closedOn', null);
            this.model.open(_.bind(function () {
                this.render();
                this.options.onSave(this.model)
            }, this), !notify);
        }, this));
    },
    closeRFI: function () {
        this.checkNotify('Would you like to notify users that this RFI has been closed?', _.bind(function (notify) {
            this.model.set('closedOn', new Date());
            this.model.close(_.bind(function () {
                this.render();
                this.options.onSave(this.model)
            }, this), !notify);
        }, this));
    },
    checkActiveResponse: function (callback) {
        let aRes = this.$('.item-new-response').val();
        if (_.size(aRes) > 0) {
            new PJQ.views.modals.YesNo({
                header: "Post Response?",
                body: 'You typed a response but did not click <b>Post Response</b>.  Would you like to post this response before continuing?',
                onYes: _.bind(function () {
                    this.addResponse(callback);
                }, this),
                onNo: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(true);
            }
        }
    },
    saveDraftClicked: function () {
        this.save(true);
    },
    saveAndOpenClicked: function () {
        this.model.set('status', PJQ.constants.rfi.statuses.OPEN);
        this.save();
    },
    saveClicked: function () {
        this.save();
    },
    save: function (draft = false) {
        if (!this.validate())
            return;

        this.checkActiveResponse(() => {
            if (this.fileUploader.isUploading()) {
                new PJQ.views.BaseModal({
                    header: "Files Uploading",
                    body: "You can't save while files are uploading"
                });
            } else {
                if (this.model.hasChanged() || this.model.isNew()) {
                    this.model.save(null, {
                        notify: true,
                        urlOptions: {
                            draft: draft
                        },
                        success: () => {
                            _.each(this.changedAnnotations.models, (annotation) =>{
                                  if(annotation.isNew()){
                                      annotation.set('contextId', this.model.id);
                                  }
                            });
                            this.changedAnnotations.saveAll(() => {
                                if (this.options.isAdmin) {
                                    this.model.set('isRead', true);
                                }
                                if (this.options.onSave) {
                                    this.options.onSave(this.model);
                                }
                                this.removeModal();
                            });
                        }
                    });
                } else {
                    this.removeModal();
                }
            }
        });
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.checkActiveResponse(_.bind(function () {
                        this.onClose(this.model);
                        if (typeof this.options.onClose === 'function') {
                            this.options.onClose(this.model);
                        }
                        this.removeModal();
                    }, this));
                }, this)
            });
        } else {
            this.checkActiveResponse(_.bind(function () {
                this.onClose(this.model);
                this.removeModal();
            }, this));
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this RFI?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    },
    downloadAllAttachments: function () {
        this.options.project.downloadAttachments(_.map(this.model.attachments.models, function (attachment) {
            return new PJQ.models.files.File({
                entryId: attachment.get('entryId'),
                guid: attachment.get('guid')
            });
        }));
    }
});

PJQ.views.rfi.AttachmentManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.RFI, 'Attachment-Management')
    },
    events: {
        'click .rfi-attachment': 'attachmentClicked'
    },
    afterRender: function () {
        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfi-attachment-file-upload'),
            endpoint: this.options.endpoint,
            collection: this.collection,
            onDelete: function (file, callback) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "Are you sure you want to delete this attachment?",
                    onDelete: _.bind(function () {
                        file.destroy();
                        callback();
                    }, this)
                });
            }
        });
    },
    attachmentClicked: function (e) {
        let selectedAttachment = this.model.attachments.get($(e.currentTarget).data('cid'));
        this.viewAttachment(selectedAttachment);
    },
    viewAttachment: function (attachment) {
        PJQ.app.view.renderPhotoViewer({
            model: attachment
        });
    }
});
